import { collection, doc, query, where } from "firebase/firestore";
import {
  useFirestore,
  useFirestoreCollectionData,
  useFirestoreDocData,
} from "reactfire";
import { Client } from "../models/client";

export const useClients = (): Client[] => {
  const firestore = useFirestore();
  const coll = collection(firestore, "clients");
  const qref = query(coll);

  const { data: posts } = useFirestoreCollectionData(qref, {
    idField: "id",
  });

  return (posts as any) || [];
};
